import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { DownloadVideo, PinUnpinVideoDecorated } from 'components/video-box';
import { VideoContextMenuDecorated } from 'components/video-context-menu';
import { VideoShareDropdownDecorated } from 'components/context-menu/video-share-dropdown';

const Component = ({ video }) => (
  <Fragment>
    <DownloadVideo video={video} />
    <PinUnpinVideoDecorated video={video} page={'saved-videos'} />
    <VideoShareDropdownDecorated />
    <VideoContextMenuDecorated video={video} testPrefix="saved-videos-" />
  </Fragment>
);

export const VideoControlsMenu = ({ video }) => <Component video={video} />;

VideoControlsMenu.propTypes = {
  video: PropTypes.object.isRequired,
};
